import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ClientProtectedRoute = ({ children }) => {
    // Assumiamo che il login del cliente imposti 'client_logged_in' a 'true' in localStorage
    const isClientLoggedIn = localStorage.getItem('client_logged_in') === 'true';

    if (!isClientLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    return children ? children : <Outlet />;
};

export default ClientProtectedRoute;